export default {
  title: 'MODO',
  login: {
    title: 'Sign in to get started',
    button: 'Sign in',
    processing: 'Signing in...',
  },
  signup: {
    title: 'Sign up to get started',
    button: 'Sign up',
    processing: 'Signing up...',
  },
  form: {
    username: 'Username',
    usernamePlaceholder: 'Enter your username',
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    confirmPassword: 'Confirm Password',
    confirmPasswordPlaceholder: 'Re-enter your password',
    email: 'Email',
    emailPlaceholder: 'Enter your email',
    nickname: 'Nickname',
    nicknamePlaceholder: 'Enter your nickname',
  },
  guest: {
    button: 'Continue as Guest',
  },
  toggle: {
    toSignup: "Don't have an account? Sign up",
    toLogin: 'Already have an account? Sign in',
  },
}
